export const siteSettings = {
  name: "Hex Hold",
  link: "https://hexhold.net",
  email: "support@hexhold.net",
  appLink: "https://app.hexhold.net",
};
